import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApplicationFormAPI } from '../shared/constant/url.constant';
import { ApiService } from '../shared/services/api.service';

@Injectable({
  providedIn: 'root',
})
export class ApplicationFormService {
  constructor(
    private readonly http: HttpClient,
    private readonly apiService: ApiService
  ) {}

  // Utility to get headers with user-id and agency-id if available
  private getHeaders(includeAgencyId: boolean = true): HttpHeaders {
    const userId = sessionStorage.getItem('userId');
    const agencyId = sessionStorage.getItem('agencyId');
    const token = sessionStorage.getItem('applicationToken');
    let headers = new HttpHeaders();
    if(token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    if (userId) {
      headers = headers.set('user-id', userId);
    }
    if (includeAgencyId && agencyId) {
      headers = headers.set('agency-id', agencyId);
    }
    return headers;
  }

  getApplicationFormJson(): Observable<any> {
    const agencyId = sessionStorage.getItem('agencyId');
    return this.apiService.get(
      `${ApplicationFormAPI.GetApplicationForm}${agencyId}/application-form`,
      { headers: this.getHeaders() }
    );
  }

  submitPayload(payload: any): Observable<any> {
    return this.apiService.post(
      ApplicationFormAPI.PostSubFormData,
      payload,
      { headers: this.getHeaders() }
    );
  }

  getSubFormFormData(data: any): Observable<any> {
    return this.apiService.get(
      `${ApplicationFormAPI.GetSubFormData}${data}`,
      { headers: this.getHeaders() }
    );
  }

  getFundingSource(): Observable<any> {
    const agencyId = sessionStorage.getItem('agencyId');
    return this.apiService.get(
      `${ApplicationFormAPI.GetFundingSource}${agencyId}/funding-sources`,
      { headers: this.getHeaders() }
    );
  }

  updateRating(rating: any, feedback: any, applicationId: any): Observable<any> {
    const requestBody = { rating, feedback };
    return this.http.put(
      `${ApplicationFormAPI.UpdateRating}${applicationId}/rating`,
      requestBody,
      { headers: this.getHeaders(), responseType: 'text' }
    );
  }
}